import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { SortableHandle } from "react-sortable-hoc";

export const DragHandle = SortableHandle(() => (
  <div className="drag-handle">
    <FontAwesomeIcon icon={"grip-vertical"} />
  </div>
));
